var _defs, _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack1107({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4,10.51v-5H7.38v.6H4.66V7.64H7v.59H4.66v2.28Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.22,10.51v-5H10.1a2.37,2.37,0,0,1,.92.16,1.16,1.16,0,0,1,.54.46,1.3,1.3,0,0,1,.2.67,1.11,1.11,0,0,1-.18.6,1.24,1.24,0,0,1-.52.46,1.31,1.31,0,0,1,.69.45,1.2,1.2,0,0,1,.25.76,1.45,1.45,0,0,1-.15.66,1.23,1.23,0,0,1-.37.46,1.4,1.4,0,0,1-.55.25,3.09,3.09,0,0,1-.8.09ZM8.88,7.6H10a2.26,2.26,0,0,0,.63-.06A.72.72,0,0,0,11,7.29a.74.74,0,0,0,.12-.44A.77.77,0,0,0,11,6.42a.56.56,0,0,0-.34-.26,2.71,2.71,0,0,0-.76-.07h-1Zm0,2.31h1.25a2.57,2.57,0,0,0,.45,0A1,1,0,0,0,11,9.75a.66.66,0,0,0,.25-.27.88.88,0,0,0,.1-.43.85.85,0,0,0-.14-.48.81.81,0,0,0-.4-.3A2.68,2.68,0,0,0,10,8.19H8.88Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 1,
    y: 2.5,
    width: 14,
    height: 11
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack1107);
export default __webpack_public_path__ + "static/media/Symbolpack_1_107.eded584c74cbca69ccbe2c6afc43fb37.svg";
export { ForwardRef as ReactComponent };